// Serviço de templates de sistema (modelos).
// Consome a API real com o filtro `isSystemTemplate=true` server-side.

import { listTemplates } from "../../utils/services/rsvp";

// Busca modelos de um tipo específico (email | web).
// Usado pelo ModalPickTemplate ao oferecer modelos prontos no "Criar Template".
export async function getMockSystemTemplates({ jwt, type }) {
  const res = await listTemplates({
    // id undefined → hits `/templates/defaults` no serviço
    jwt,
    offset: 1,
    limit: 200,
    type,
    name: "",
    isSystemTemplate: true,
  });
  return res?.data?.data?.templates || [];
}
